"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _createSvg = require("../createSvg");
var _interfaces = require("../interfaces");
var _SVGIconWithSizes;
var _default = (0, _createSvg.createSvg)('IconDisabled', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM13 8C13 10.7614 10.7614 13 8 13C6.98092 13 6.03304 12.6951 5.24261 12.1716L12.1716 5.24261C12.6951 6.03304 13 6.98092 13 8ZM3.8284 10.7574L10.7574 3.8284C9.96696 3.30488 9.01908 3 8 3C5.23858 3 3 5.23858 3 8C3 9.01908 3.30488 9.96696 3.8284 10.7574Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10ZM17 10C17 13.866 13.866 17 10 17C8.42766 17 6.97641 16.4816 5.80783 15.6064L15.6064 5.80783C16.4816 6.97641 17 8.42766 17 10ZM4.39362 14.1922L14.1922 4.39362C13.0236 3.5184 11.5723 3 10 3C6.13401 3 3 6.13401 3 10C3 11.5723 3.5184 13.0236 4.39362 14.1922Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM21 12C21 16.9706 16.9706 21 12 21C9.87499 21 7.92199 20.2635 6.38231 19.0319L19.0319 6.38231C20.2635 7.92199 21 9.87499 21 12ZM4.9681 17.6177L17.6177 4.9681C16.078 3.73647 14.125 3 12 3C7.02944 3 3 7.02944 3 12C3 14.125 3.73647 16.078 4.9681 17.6177Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M31 16C31 24.2843 24.2843 31 16 31C7.71573 31 1 24.2843 1 16C1 7.71573 7.71573 1 16 1C24.2843 1 31 7.71573 31 16ZM28 16C28 22.6274 22.6274 28 16 28C13.2269 28 10.6736 27.0594 8.64153 25.4798L25.4798 8.64153C27.0594 10.6736 28 13.2269 28 16ZM6.52021 23.3585L23.3585 6.52021C21.3264 4.94062 18.7731 4 16 4C9.37258 4 4 9.37258 4 16C4 18.7731 4.94062 21.3264 6.52021 23.3585Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));
exports.default = _default;